import { render, staticRenderFns } from "./VisitLink.vue?vue&type=template&id=f15bbce0&scoped=true"
import script from "./VisitLink.vue?vue&type=script&lang=js"
export * from "./VisitLink.vue?vue&type=script&lang=js"
import style0 from "./VisitLink.vue?vue&type=style&index=0&id=f15bbce0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15bbce0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/moderlab/moderclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f15bbce0')) {
      api.createRecord('f15bbce0', component.options)
    } else {
      api.reload('f15bbce0', component.options)
    }
    module.hot.accept("./VisitLink.vue?vue&type=template&id=f15bbce0&scoped=true", function () {
      api.rerender('f15bbce0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/VisitLink/VisitLink.vue"
export default component.exports